import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonuserService } from './pesonuser/personuser.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from '../token/interceptor';
import { PeopleService } from './people/people.service';
import { TranscriptdetailService } from './transcriptdetail/transcriptdetail.service';
import { AcademiccalendarService } from './academiccalendar/academiccalendar.service';
import { TitulacionService } from './titulacion/titulacion.service';
import { AddressscheduleService } from './addressschedule/addressschedule.service';
import { VwsDocentesCampusTodosService } from './vwsDocentesCampusTodos/vwsDocentesCampusTodos.service';
import { VwsNivelesInglesEstudianteService } from './uitey_vws_niveles_ingles_estudiante/serviceUitey_vws_niveles_ingles_estudiante';
import { InformacionPersonalUnaeService } from './unae_yachaytech/informacion-personal-unae.service';
import { InformacionPersonalYachaytechService } from './unae_yachaytech/informacion-personal-yachaytech.service';
import { BuildingService } from './building/building.service';
import { RoomService } from './room/room.service';
import { VwsVinculacionSolicitudEstudianteService } from './vwsVinculacionSolicitudEstudiante/vwsVinculacionSolicitudEstudiante.service';
import { UiteyPerdidaGratuidadService } from './uiteyPerdidaGratuidad/uiteyPerdidaGratuidad.service';
import { CodeStoplistService } from './codeStoplist/codeStoplist.service';
import { StoplistService } from './stoplist/stoplist.service';
import { UiteyCabDetalleElectivasService } from './detalle_estudiante/uiteyCabDetalleElectivas/uiteyCabDetalleElectivas.service';
import { UiteyCabReferenciaCruzadaService } from './detalle_estudiante/uiteyCabReferenciaCruzada/uiteyCabReferenciaCruzada.service';
import { UiteyDetalleElectivasService } from './detalle_estudiante/uiteyDetalleElectivas/uiteyDetalleElectivas.service';
import { UiteyDetalleEstudianteService } from './detalle_estudiante/uiteyDetalleEstudiante/uiteyDetalleEstudiante.service';
import { UiteyFlujoProcesoReferenciasCruzadasService } from './detalle_estudiante/uiteyFlujoProcesoReferenciasCruzadas/uiteyFlujoProcesoReferenciasCruzadas.service';
import { UiteyReferenciaCruzadaService } from './detalle_estudiante/uiteyReferenciaCruzada/uiteyReferenciaCruzada.service';
import { CodeCurriculumService } from './codeCurriculum/codeCurriculum.service';
import { UiteyTipoProcesoService } from './detalle_estudiante/uiteyTipoProceso/uiteyTipoProceso.service';
import { ViewMallasCurricularesService } from './viewMallasCurriculares/viewMallasCurriculares.service';
import { UiteyResolucionReferenciaCruzadaService } from './detalle_estudiante/uiteyResolucionReferenciaCruzada/uiteyResolucionReferenciaCruzada.service';
import { UiteyResolucionEstudianteService } from './detalle_estudiante/uiteyResolucionEstudiante/uiteyResolucionEstudiante.service';
import { UiteyViewDetallesGeneralesPersonasService } from './uiteyViewDetallesGeneralesPersonasService/uiteyViewDetallesGeneralesPersonasService.service';
import { PersonphoneService } from './personphone/personphone.service';
import { DemographicsService } from './demographics/demographics.service';
import { CodeDepartamentService } from './codeDepartament/codeDepartament.service';
import { UiteyDetalleElectivasHistorialService } from './detalle_estudiante/uiteyDetalleElectivasHistorial/uiteyDetalleElectivasHistorial.service';
import { UiteyDetalleEstudianteHistorialService } from './detalle_estudiante/uiteyDetalleEstudianteHistorial/uiteyDetalleEstudianteHistorial.service';
import { EventService } from './event/event.service';
import { SectionsService } from './sections/sections.service';
import { UiteyDetalleProcesosEjecucionService } from './detalle_estudiante/uiteyDetalleProcesosEjecucion/uiteyDetalleProcesosEjecucion.service';
import { UiteyDetalleProcesoService } from './detalle_estudiante/uiteyDetalleProceso/uiteyDetalleProceso.service';
import { EvaluacionService } from './evaluacion/evaluacion.service';
import { VwsDistribucionDocenteEscuelaService } from './vwsDistribucionDocenteEscuela/vwsDistribucionDocenteEscuela.service';
import { UiteyCodigosSimilitudesService } from './uiteyCodigosSimilitudes/uiteyCodigosSimilitudes.service';
import { EvalReportesService } from './evalReportes/evalReporte.service';
import { UiteyDetalleObservacionesReferenciaService } from './detalle_estudiante/uiteyDetalleObservacionesReferencia/uiteyDetalleObservacionesReferencia.service';
import { ViewUiteyPromediosPonderadosService } from './viewUiteyPromediosPonderados/viewUiteyPromediosPonderados.service';
import { CodeCollageService } from './codeCollage/codeCollage.service';
import { AbtsettingsService } from './abtsettings/abtsettings.service';
import { UiteyMoodleCourseSectionService } from './uiteyMoodleCourseSection/uiteyMoodleCourseSection.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedCampusModule {
  static forRoot(): ModuleWithProviders<SharedCampusModule> {
    return {
      ngModule: SharedCampusModule,
      providers: [
        PersonuserService,
        PeopleService,
        TranscriptdetailService,
        AcademiccalendarService,
        AddressscheduleService,
        AbtsettingsService,
        VwsDocentesCampusTodosService,
        TitulacionService,
        BuildingService,
        RoomService,
        VwsNivelesInglesEstudianteService,
        InformacionPersonalUnaeService,
        InformacionPersonalYachaytechService,
        VwsVinculacionSolicitudEstudianteService,
        UiteyPerdidaGratuidadService,
        CodeStoplistService,
        StoplistService,
        UiteyCabDetalleElectivasService,
        UiteyCabReferenciaCruzadaService,
        UiteyDetalleElectivasService,
        UiteyDetalleEstudianteService,
        UiteyFlujoProcesoReferenciasCruzadasService,
        UiteyReferenciaCruzadaService,
        CodeCurriculumService,
        UiteyTipoProcesoService,
        ViewMallasCurricularesService,
        UiteyResolucionEstudianteService,
        UiteyResolucionReferenciaCruzadaService,
        UiteyViewDetallesGeneralesPersonasService,
        PersonphoneService, DemographicsService,
        CodeDepartamentService,
        UiteyDetalleElectivasHistorialService,
        UiteyDetalleEstudianteHistorialService,
        EventService,
        SectionsService,
        UiteyDetalleProcesoService,
        UiteyDetalleProcesosEjecucionService,
        EvaluacionService, VwsDistribucionDocenteEscuelaService,
        UiteyCodigosSimilitudesService,
        EvalReportesService,
        UiteyDetalleObservacionesReferenciaService,
        ViewUiteyPromediosPonderadosService,
        CodeCollageService,
        UiteyMoodleCourseSectionService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }
      ]
    };
  }
}
